// extracted by mini-css-extract-plugin
export var gif = "_di-0";